import React, { useEffect, useState } from 'react';
import {
    GoogleMap, MarkerF, Marker, InfoWindow, CircleF
} from "@react-google-maps/api";
import "./ActivitiesMaps.scss";
import { MapProps } from '../../Models/ActivitiesModel';
import campIcon from "../../Assets/Activities/campMapIcon.svg";
import personalIcon from "../../Assets/Activities/personalMapIcon.svg";
import shareIcon from "../../Assets/Activities/share_activity.svg";
import LikeIcon from "../../Assets/Activities/like_activity.svg";
import ActivityFill from "../../Assets/HeartFill/ActivityFill.svg";
import StarIcon from '@mui/icons-material/Star';
import { GetSessionStorageData, SetSessionStorageData, encryptPassData, nullUndefinedEmptyCheck } from '../../Utilities/Helpers/Helper';
import { API_END_POINTS, AUTHENTICATION, GLOBAL_CONSTANTS, ROUTES, TUTORMAPCONSTANT } from '../../Constants/Constants';
import { setLocation, setLocationName, setLoginSignUpOpen } from '../../Redux/Reducer/Reducer';
import { useDispatch, useSelector } from 'react-redux';
import { axiosInstance } from '../../Utilities/Interceptor/Interceptor';
import toast from 'react-hot-toast';
import WebShareComponent from '../WebShare/WebShare';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

const ActivitiesMaps = ({ zoom, radius, containerStyle, disable, zoomControl, draggable, clickableIcons, getOneTutor, lat, lang, filter, searchValue, initFilter, initSort, ActivitiesList, onLocationChange }: any) => {
    const [currentLocation, setCurrentLocation] = useState<any>(null);
    const [selectedLocation, setSelectedLocation] = useState<any>(null);
    const [List, setList] = useState<any>([]); 
    const [userProfileImg, setUserProfileImg] = useState<any>();
    const [showMapTooltip, setShowMapTooltip] = useState<boolean>(false);
    const [showMapTooltipMobile, setShowMapTooltipMobile] = useState<boolean>(false); 
    const [tooltipPos, setTooltipPos] = useState<{ x: number; y: number }>({ x: 0, y: 0 }); 
    const [isMobileView, setIsMobileView] = useState<boolean>(window.innerWidth <= 636);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const language: any = useSelector((state: any) => {
        return state.languageReducer.language;
    });

    const isLoaded = useSelector((state: any) => {
        return state.googleMapLoadedReducer.isGoogleMapLoaded;
    });
      const HeaderLocation: any = useSelector((state: any) => {
        return state.locationReducer.location;
    });


    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 636);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setShowMapTooltipMobile(isMobileView);
    }, [isMobileView]);

    useEffect(() => {
        let locationToUse = null;
        
        if (HeaderLocation?.lat && HeaderLocation?.lng) {
            locationToUse = HeaderLocation;
        } else {
            const storedLocation = GetSessionStorageData(AUTHENTICATION.SHARED.ACTIVITIES_LOCATION);
            if (storedLocation) {
                try {
                    locationToUse = JSON.parse(storedLocation);
                } catch (e) {
                    console.error('Error parsing stored location:', e);
                }
            }
        }

        if (!locationToUse && lat && lang) {
            locationToUse = { lat: parseFloat(lat), lng: parseFloat(lang) };
        }

        if (locationToUse) {
            setCurrentLocation(locationToUse);
            dispatch(setLocation(locationToUse));
            
            if (isLoaded) {
                ActivityListApi(locationToUse.lat, locationToUse.lng);
            }
        }

        setUserProfileImg(GetSessionStorageData(AUTHENTICATION.SHARED.PROFILE_PICTURE));
    }, [HeaderLocation, lat, lang, isLoaded]);

  
    const payload = (overrideLat?: string | number, overrideLng?: string | number) => {
        var priceValue: any = [];
        var experienceValue: any = [];
        var ageValue: any = [];
        var timeValue: any = [];
        if (initFilter.price[0] === filter.price[0] && initFilter.price[1] === filter.price[1]) {
            priceValue = [];
        } else {
            priceValue = { min: filter.price[0], max: filter.price[1] };
        }
        if (initFilter.experience[0] === filter.experience[0] && initFilter.experience[1] === filter.experience[1]) {
            experienceValue = [];
        } else {
            experienceValue = { min: filter.experience[0], max: filter.experience[1] };
        }
        if (initFilter.age[0] === filter.age[0] && initFilter.age[1] === filter.age[1]) {
            ageValue = [];
        } else {
            ageValue = { min: filter.age[0], max: filter.age[1] };
        }
        if (initFilter.time[0] === filter.time[0] && initFilter.time[1] === filter.time[1]) {
            timeValue = [];
        } else {
            timeValue = { min: timeFormat(filter.time[0]), max: timeFormat(filter.time[1]) };
        }
        const usedLat = overrideLat !== undefined ? overrideLat : lat;
        const usedLng = overrideLng !== undefined ? overrideLng : lang;

        return {
            latitude: usedLat?.toString(),
            longitude: usedLng?.toString(),
            radius: filter.radius,
            search: searchValue ? searchValue : "",
            price: priceValue,
            experience: experienceValue,
            age: ageValue,
            time: timeValue,
            activities: filter.activities,
            gender: filter.gender,
            available: filter.available,
            rating: filter.rating,
        };
    };

    const ActivityListApi = (overrideLat?: number | string, overrideLng?: number | string) => {
        var pay = payload(overrideLat, overrideLng);
        axiosInstance
            .post(`${API_END_POINTS.ACTIVITIESLIST}`, pay)
            .then((Response: any) => {
                setList(Response?.data?.result?.data);
            })
            .catch((error) => {
                console.error("Error fetching activities list:", error);
            });
    };

    const timeFormat = (value: number) => {
        if (value === 24) return `23:59`;
        const hours = Math.floor(value);
        const minutes = (value % 1) * 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };

    const mapOptions = {
        disableDefaultUI: disable,
        zoomControl: zoomControl,
        draggable: draggable,
        clickableIcons: clickableIcons,
        disableDoubleClickZoom: disable,
        gestureHandling: "greedy",
        styles: [
            {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }],
            },
        ],
    };

    useEffect(() => {
        if (initSort?.price || initSort?.rating) {
            handleProceedSort(initSort?.price, initSort?.rating);
        }
    }, [initSort]);

    const handleProceedSort = (checkedPrice: any, checkedRating: any) => {
        if (checkedPrice === 'high') {
            const campData = [...(List?.camp || [])].sort((a: any, b: any) => b?.least_price - a?.least_price);
            const personalData = [...(List?.personal || [])].sort((a: any, b: any) => b?.least_price - a?.least_price);
            setList({ camp: campData, personal: personalData });
        } else if (checkedPrice === 'low') {
            const campData = [...(List?.camp || [])].sort((a: any, b: any) => a?.least_price - b?.least_price);
            const personalData = [...(List?.personal || [])].sort((a: any, b: any) => a?.least_price - b?.least_price);
            setList({ camp: campData, personal: personalData });
        } else if (checkedRating === 'high') {
            const campData = [...(List?.camp || [])].sort((a: any, b: any) => b?.least_rating - a?.least_rating);
            const personalData = [...(List?.personal || [])].sort((a: any, b: any) => b?.least_rating - a?.least_rating);
            setList({ camp: campData, personal: personalData });
        } else if (checkedRating === 'low') {
            const campData = [...(List?.camp || [])].sort((a: any, b: any) => a?.least_rating - b?.least_rating);
            const personalData = [...(List?.personal || [])].sort((a: any, b: any) => a?.least_rating - b?.least_rating);
            setList({ camp: campData, personal: personalData });
        }
    };

    const handleChangeFavourites = (val: any, id: any, type: any, campId: any) => {
        const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
        if (nullUndefinedEmptyCheck(accessToken)) {
            var payload: any = type === "camp"
                ? {
                    service_provider_type: GLOBAL_CONSTANTS.INITIAL_VALUES.THREE_INT,
                    service_provider: id,
                    is_favourite: !val,
                    camp_session: campId
                }
                : {
                    service_provider_type: GLOBAL_CONSTANTS.INITIAL_VALUES.TWO_INT,
                    service_provider: id,
                    is_favourite: !val
                };
            axiosInstance
                .post(`${API_END_POINTS.FAVOURITE__ADD}`, payload)
                .then((Response: any) => {
                    if (Response?.data?.status) {
                        toast.success(Response?.data?.message, {
                            position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION
                        });
                        ActivityListApi();
                    }
                })
                .catch((error) => {
                    console.error("handleChangeFavourites ~ error:", error);
                });
        } else {
            dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
        }
    };

    const geocoder: any = isLoaded ? new window.google.maps.Geocoder() : '';

    const getFormattedAddress = (lat: any, lng: any) => {
        geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
            if (status) {
                var addressComponents = results[GLOBAL_CONSTANTS.INITIAL_VALUES.ZERO_INT]?.address_components;
                if (results[GLOBAL_CONSTANTS.INITIAL_VALUES.ZERO_INT]?.address_components?.length > 0) {
                    const regionComponent = addressComponents?.find((component: any) => component?.types.includes("locality"));
                    const countryComponent = addressComponents?.find((component: any) => component?.types.includes("country"));
                    const countryName = countryComponent ? countryComponent.long_name : null;
                    const regionName = regionComponent ? regionComponent.long_name : null;
                    SetSessionStorageData(AUTHENTICATION.SHARED.REGION_NAME, regionName);
                    SetSessionStorageData(AUTHENTICATION.SHARED.COUNTRY_NAME, countryName);
                    dispatch(setLocationName(countryName));
                }
            }
        });
    };

    const navigateDetailedView = (Details: any) => {
        navigate(ROUTES.ACTIVITY_DETAILE_VIEW + "?id=" + encryptPassData(Details?.id) + '&type=' + encryptPassData(Details?.is_service_type), { state: { Activies_Detailes: Details } });
    };

    const customMarkerIconStyle = {
        width: "40px",
        height: "40px",
        borderRadius: "50%",
    };

    return isLoaded ? (
        <div style={{ position: "relative", ...containerStyle }}>
            <div
                onMouseEnter={() => !isMobileView && setShowMapTooltip(true)}
                onMouseMove={(e: React.MouseEvent<HTMLDivElement>) => {
                    if (isMobileView) return;
                    const rect = (e.currentTarget as HTMLDivElement).getBoundingClientRect();
                    setTooltipPos({ x: e.clientX - rect.left, y: e.clientY - rect.top });
                }}
                onMouseLeave={() => setShowMapTooltip(false)}
                onTouchStart={() => setShowMapTooltipMobile(false)}
            >
                <GoogleMap
                    id={TUTORMAPCONSTANT.MAP__ID}
                    mapContainerStyle={containerStyle}
                    zoom={zoom}
                    center={currentLocation}
                    options={mapOptions}
                    onClick={(e: any) => {
                        setSelectedLocation(null);
                        if (isMobileView) setShowMapTooltipMobile(false);
                        if (e?.latLng && typeof onLocationChange === "function") {
                          const latVal = e.latLng.lat();
                          const lngVal = e.latLng.lng();
                          onLocationChange(latVal, lngVal);
                        }
                    }}
                    onMouseOut={() => setSelectedLocation(null)}
                >
                    <CircleF
                        center={{ lat: parseFloat(HeaderLocation?.lat), lng: parseFloat(HeaderLocation?.lng) }}
                        radius={radius}
                        options={{
                            fillColor: '#178FFF',
                            strokeColor: 'rgba(79, 139, 255, 0.60)',
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillOpacity: 0.1,
                        }}
                    />
                    {HeaderLocation && (
                        <MarkerF
                            position={HeaderLocation}
                            draggable={draggable}
                            zIndex={999}
                            shape={{ coords: [17, 17, 18], type: "circle" }}
                            icon={{
                                scaledSize: new window.google.maps.Size(40, 40),
                                url: userProfileImg,
                            }}
                            onDragEnd={async (e: any) => {
                                if (!e.latLng) return;

                                const locationData = {
                                    lat: e.latLng.lat(),
                                    lng: e.latLng.lng()
                                };

                                try {
                                    const geocoder = new window.google.maps.Geocoder();
                                    const response = await geocoder.geocode({ location: locationData });
                                    
                                    if (response.results[0]) {
                                        const addressComponents = response.results[0].address_components;
                                        const city = addressComponents.find((component: any) => 
                                            component.types.includes('locality') || 
                                            component.types.includes('administrative_area_level_1')
                                        );
                                        const countryComponent = addressComponents.find((component: any) => 
                                            component.types.includes('country')
                                        );
                                        
                                        const cityName = city?.long_name;
                                        const countryName = countryComponent?.long_name;
                                        const displayName = cityName ? `${cityName}, ${countryName}` : countryName;

                                        setCurrentLocation(locationData);
                                        
                                        SetSessionStorageData(AUTHENTICATION.SHARED.ACTIVITIES_LOCATION, JSON.stringify(locationData));
                                        SetSessionStorageData(AUTHENTICATION.SHARED.REGION_NAME, cityName || '');
                                        SetSessionStorageData(AUTHENTICATION.SHARED.COUNTRY_NAME, countryName || '');
                                        
                                        dispatch(setLocation(locationData));
                                        dispatch(setLocationName(displayName));

                                        const mapDiv = document.getElementById(TUTORMAPCONSTANT.MAP__ID);
                                        if (mapDiv) {
                                            const point = new window.google.maps.Point(
                                                e.domEvent.clientX - mapDiv.getBoundingClientRect().left,
                                                e.domEvent.clientY - mapDiv.getBoundingClientRect().top
                                            );
                                            setTooltipPos({ x: point.x + 12, y: point.y + 12 });
                                            setShowMapTooltip(true);
                                        }

                                        ActivityListApi(locationData.lat, locationData.lng);

                                        if (typeof onLocationChange === "function") {
                                            onLocationChange(locationData.lat, locationData.lng);
                                        }
                                    }
                                } catch (error) {
                                    console.error('Error updating location:', error);
                                }
                            }}
                            onClick={() => setShowMapTooltip(false)}
                        />
                    )}
                    {((ActivitiesList && (ActivitiesList.personal || ActivitiesList.camp)) ? ActivitiesList : List)?.personal?.map((data: any) => {
                        let object = {
                            lat: parseFloat(data.latitude),
                            lng: parseFloat(data.longitude)
                        };
                        return (
                            <Marker
                                key={`${data.id}-personal`} 
                                position={object}
                                icon={{
                                    scaledSize: lat == data?.latitude && lang == data?.longitude
                                        ? new window.google.maps.Size(65, 65)
                                        : new window.google.maps.Size(40, 40),
                                    url: personalIcon,
                                }}
                                onMouseOver={() => setSelectedLocation(data)}
                                onClick={() => setSelectedLocation(data)}
                                animation={lat == data?.latitude && lang == data?.longitude ? window.google.maps.Animation.DROP : undefined}
                            >
                                {selectedLocation === data && (
                                    <InfoWindow
                                        onCloseClick={() => setSelectedLocation(null)}
                                        options={{ maxWidth: 372 }}
                                    >
                                        <div
                                            className=""
                                            onClick={() => navigateDetailedView(data)}
                                            onMouseEnter={() => setSelectedLocation(data)}
                                            onMouseLeave={() => setSelectedLocation(null)}
                                        >
                                            <div className="Hover__Card" onClick={() => {
                                                if (clickableIcons) {
                                                    getOneTutor(data);
                                                } else {
                                                    navigateDetailedView(data);
                                                }
                                            }}>
                                                <div className="rightside_contant">
                                                    <div className="w-100">
                                                        <div className="user__Detailes">
                                                            <div className="user__name notranslate">
                                                                {language === "English"
                                                                    ? data?.camp_session_title
                                                                    : data?.arabic_camp_session_title || data?.camp_session_title}
                                                            </div>
                                                            <div className="user__icon__wrapper" onClick={(e) => e.stopPropagation()}>
                                                                <WebShareComponent
                                                                    params={ROUTES.ACTIVITY_DETAILE_VIEW + "?id=" + encryptPassData(data?.id) + "&type=" + encryptPassData(data?.is_service_type)}
                                                                >
                                                                    <img src={shareIcon} alt="shareIcon" />
                                                                </WebShareComponent>
                                                                <img
                                                                    src={data?.is_favourite ? ActivityFill : LikeIcon}
                                                                    alt="LikeIcon"
                                                                    onClick={() => handleChangeFavourites(data?.is_favourite, data?.user, "personal", data?.id)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="user__Detailes__rating_Activities">
                                                            <div className="card__title">By {data?.camp_name}</div>
                                                        </div>
                                                        <div className="user__Detailes__rating_Activities">
                                                            <div className="card__title">
                                                                {moment(new Date(data?.start_date)).format("MMM DD")} -{" "}
                                                                {moment(new Date(data?.end_date)).format("MMM DD")}
                                                            </div>
                                                        </div>
                                                        <div className="user__Detailes__rating_Activities">
                                                            <div className="d-flex gap-2 align-items-center">
                                                                <div className="title">{"AED " + data?.total_class_fee}</div>
                                                                <div className="card__title">for {data?.total_class} classes</div>
                                                            </div>
                                                            <div className="d-flex gap-2 align-items-center">
                                                                {data?.rating ? <StarIcon className="StarIcon" /> : null}
                                                                <div className="card__title">{data?.rating}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </InfoWindow>
                                )}
                            </Marker>
                        );
                    })}
                    {((ActivitiesList && (ActivitiesList.personal || ActivitiesList.camp)) ? ActivitiesList : List)?.camp?.map((data: any) => {
                        let object = {
                            lat: parseFloat(data.latitude),
                            lng: parseFloat(data.longitude)
                        };
                        return (
                            <Marker
                                key={`${data.id}-camp`} 
                                position={object}
                                icon={{
                                    scaledSize: lat == data?.latitude && lang == data?.longitude
                                        ? new window.google.maps.Size(65, 65)
                                        : new window.google.maps.Size(40, 40),
                                    url: campIcon,
                                }}
                                onMouseOver={() => setSelectedLocation(data)}
                                onClick={() => setSelectedLocation(data)}
                            >
                                {selectedLocation === data && (
                                    <InfoWindow
                                        onCloseClick={() => setSelectedLocation(null)}
                                        options={{ maxWidth: 372 }}
                                    >
                                        <div
                                            className=""
                                            onClick={() => navigateDetailedView(data)}
                                            onMouseEnter={() => setSelectedLocation(data)}
                                            onMouseLeave={() => setSelectedLocation(null)}
                                        >
                                            <div className="Hover__Card" onClick={() => {
                                                if (clickableIcons) {
                                                    getOneTutor(data);
                                                } else {
                                                    navigateDetailedView(data);
                                                }
                                            }}>
                                                <div className="rightside_contant">
                                                    <div className="w-100">
                                                        <div className="user__Detailes">
                                                            <div className="user__name notranslate">
                                                                {language === "English"
                                                                    ? data?.camp_session_title
                                                                    : data?.arabic_camp_session_title || data?.camp_session_title}
                                                            </div>
                                                            <div className="user__icon__wrapper" onClick={(e) => e.stopPropagation()}>
                                                                <WebShareComponent
                                                                    params={ROUTES.ACTIVITY_DETAILE_VIEW + "?id=" + encryptPassData(data?.id) + "&type=" + encryptPassData(data?.is_service_type)}
                                                                >
                                                                    <img src={shareIcon} alt="shareIcon" />
                                                                </WebShareComponent>
                                                                <img
                                                                    src={data?.is_favourite ? ActivityFill : LikeIcon}
                                                                    alt="LikeIcon"
                                                                    onClick={() => handleChangeFavourites(data?.is_favourite, data?.user, "camp", data?.id)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="user__Detailes__rating_Activities">
                                                            <div className="card__title">By {data?.camp_name}</div>
                                                        </div>
                                                        <div className="user__Detailes__rating_Activities">
                                                            <div className="card__title">
                                                                {moment(new Date(data?.start_date)).format("MMM DD")} -{" "}
                                                                {moment(new Date(data?.end_date)).format("MMM DD")}
                                                            </div>
                                                        </div>
                                                        <div className="user__Detailes__rating_Activities">
                                                            <div className="d-flex gap-2 align-items-center">
                                                                <div className="title">{"AED " + data?.total_class_fee}</div>
                                                                <div className="card__title">for {data?.total_class} classes</div>
                                                            </div>
                                                            <div className="d-flex gap-2 align-items-center">
                                                                {data?.rating ? <StarIcon className="StarIcon" /> : null}
                                                                <div className="card__title">{data?.rating}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </InfoWindow>
                                )}
                            </Marker>
                        );
                    })}
                </GoogleMap>
            </div>

            {showMapTooltip && HeaderLocation && (
                <div
                    style={{
                        position: "absolute",
                        left: tooltipPos.x,
                        top: tooltipPos.y,
                        zIndex: 1200,
                        background: "#fff",
                        padding: "6px 10px",
                        borderRadius: 6,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        pointerEvents: "none",
                        fontSize: 13,
                        color: "#111"
                    }}
                >
                    {language === "English"
                        ? "Drag the pin to select your preferred location"
                        : "اسحب الدبوس لتحديد موقعك المفضل "}
                </div>
            )}

            {isMobileView && showMapTooltipMobile && (
                <div
                    style={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        bottom: 12,
                        zIndex: 1200,
                        background: "rgba(255,255,255,0.95)",
                        padding: "8px 12px",
                        borderRadius: 8,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                        pointerEvents: "none",
                        fontSize: 13,
                        color: "#111",
                        maxWidth: "90%",
                        textAlign: "center"
                    }}
                >
                    {language === "English"
                        ? "Tap map to select preferred region or drag the marker"
                        : "اضغط على الخريطة لاختيار المنطقة المفضلة أو اسحب العلامة"}
                </div>
            )}
        </div>
    ) : (
        <div>Loading map...</div> 
    );
};

export default ActivitiesMaps;